/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  onClose: () => void;
  onUpgradeClick: () => void;
};

export const EmailSupportUpgradeNudge = ({
  onClose,
  onUpgradeClick,
}: Props) => {
  const activeView = getActiveView();

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        <UpgradeButton key="upgrade" onClick={onUpgradeClick} />,
        <CancelButton key="cancel" onClick={onClose} />,
      ]}
      headingText="Upgrade to contact Support"
      id="email-support"
      image={<NudgeImage type={upgradeReasons.emailSupport} />}
      subtitleText="Paid Feature"
    />
  );
};
